import { Post } from '@/service/request/server';
import { envConfig } from '../../../env';

export function userAdminInitPassword(data) {
    return Post(envConfig.formalServer + "/cotton/userAdminInitPassword", data)
}